import { iconSize, NavSettings } from "@colorglo/ui/icons";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useMe } from "../api/hooks.ts";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";
import { useT } from "../lib/locale.ts";
import { settingsTabs } from "../lib/nav.ts";

export interface SettingsSearch {
  /** Which location is being configured. Absent means the one the sidebar has selected. */
  readonly franchise?: string;
}

export const Route = createFileRoute("/installningar")({
  validateSearch: (search: Record<string, unknown>): SettingsSearch =>
    typeof search.franchise === "string" ? { franchise: search.franchise } : {},
  component: SettingsLayout,
});

function SettingsLayout() {
  const t = useT();
  const me = useMe();
  const franchise = useSettingsFranchise();
  const tabs = settingsTabs(me.data?.franchises ?? []);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="shrink-0 border-b border-border">
        <div className="flex items-center gap-2 px-4 pt-4 md:px-6 md:pt-5">
          <NavSettings {...iconSize.control} aria-hidden="true" />
          <h1 className="text-h2">{t("settings.title")}</h1>
        </div>
        <nav
          aria-label={t("settings.title")}
          className="flex gap-1 overflow-x-auto px-4 py-3 [scrollbar-width:none] md:px-6"
        >
          {tabs.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              search={franchise === null ? {} : { franchise: franchise.id }}
              activeOptions={{ includeSearch: false }}
              className="flex shrink-0 items-center gap-2 rounded-md px-3 py-2 text-body-sm whitespace-nowrap text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
              activeProps={{
                "aria-current": "page",
                className: "bg-accent font-medium text-accent-foreground",
              }}
            >
              <item.icon {...iconSize.inline} aria-hidden="true" />
              {t(item.label)}
            </Link>
          ))}
        </nav>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto p-4 md:p-6">
        <div className="pb-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
